import { axios } from '@/utils/axios';

const RESOURCE_NAME  = '/regular-by-organization';

export default {
    get(payload) {
        return axios.get(`${RESOURCE_NAME}/`, {params: {legacy: payload}})
    },
    create(payload) {
        return axios.post(`${RESOURCE_NAME}/`, payload)
    },
    update(payload) {
        return axios.post(`${RESOURCE_NAME}/update`, payload)
    },
    remove(payload) {
        return axios.post(`${RESOURCE_NAME}/remove`, { regular_id: payload })
    },
}
